// Réseaux sociaux du club et des équipes (D-035) : des liens, affichés sur la page
// publique et dans l'app ; le bureau tient ceux du club, le staff ceux de son équipe.
import { addSocialLink, deleteSocialLink, socialLinks, updateSocialLink, type SocialLink } from '../lib/api';
import { detectNetwork, NETWORK_LABEL, normalizeUrl, type Network } from '../domain/social';
import { $, $$, html, mount, toast, type Html } from './dom';

/** Les comptes en pastilles cliquables (nouvel onglet). */
export function socialChips(links: { network: Network; url: string }[] | undefined, cls = ''): Html | '' {
  if (!links?.length) return '';
  return html`<span class="social ${cls}">${links.map(l => html`
    <a class="social-chip social-${l.network}" href="${l.url}" target="_blank" rel="noopener">${NETWORK_LABEL[l.network]}</a>`)}</span>`;
}

/** Bloc d'édition : on colle un lien, le réseau est reconnu ; un compte par réseau. */
export async function renderSocialEditor(el: HTMLElement, clubId: string, teamId: string | null, title: string, editable: boolean): Promise<void> {
  const all = await socialLinks(clubId).catch(() => [] as SocialLink[]);
  const mine = all.filter(l => l.team_id === teamId);
  if (!editable && !mine.length) { mount(el, html``); return; }
  mount(el, html`
    <section class="block social-block">
      <h3>${title}</h3>
      ${mine.length ? html`<ul class="ce-rows">${mine.map(l => html`
        <li><span><strong>${NETWORK_LABEL[l.network]}</strong> <a class="muted small" href="${l.url}" target="_blank" rel="noopener">${l.url.replace(/^https:\/\/(www\.)?/, '')}</a></span>
          ${editable ? html`<button type="button" class="sheet-x" data-unlink="${l.id}" aria-label="Retirer ${NETWORK_LABEL[l.network]}">×</button>` : ''}</li>`)}</ul>`
        : html`<p class="muted small">Aucun compte pour l'instant.</p>`}
      ${editable ? html`
        <form class="inline-form" id="f-social" novalidate>
          <input name="url" inputmode="url" maxlength="300" placeholder="Colle le lien : instagram.com/…, facebook.com/…" aria-label="Lien du compte">
          <button class="btn btn-ghost btn-sm" type="submit">Ajouter</button>
        </form>
        <p class="hint">Instagram, Facebook, TikTok, YouTube, X, Threads, LinkedIn ou un site : le réseau est reconnu tout seul. Affiché sur la page publique${teamId ? ' (carte de l’équipe)' : ''} et dans l'app.</p>` : ''}
    </section>`);
  if (!editable) return;
  const reload = () => renderSocialEditor(el, clubId, teamId, title, editable);
  for (const b of $$<HTMLButtonElement>(el, '[data-unlink]')) {
    b.addEventListener('click', async () => {
      try { await deleteSocialLink(b.dataset.unlink!); toast('Compte retiré'); await reload(); }
      catch { toast('Impossible pour le moment.', 'ko'); }
    });
  }
  const f = $<HTMLFormElement>(el, '#f-social')!;
  f.addEventListener('submit', async (e) => {
    e.preventDefault();
    const url = normalizeUrl(String(new FormData(f).get('url') ?? ''));
    if (!url) { toast('Lien non reconnu : colle l’adresse complète du compte.', 'ko'); return; }
    const network = detectNetwork(url);
    const existing = mine.find(l => l.network === network);
    try {
      if (existing) await updateSocialLink(existing.id, url);
      else await addSocialLink(clubId, teamId, network, url, mine.length);
      toast(`${NETWORK_LABEL[network]} ${existing ? 'mis à jour' : 'ajouté'}`);
      await reload();
    } catch { toast('Enregistrement impossible.', 'ko'); }
  });
}
